<template>
  <div>
    <div class="text-28 font-bold mt-6">{{ type }} Uyumu</div>
    <div class="text-lg font-normal mt-4 mb-3 flex items-center justify-between">
      <div>{{ type }}</div>
      <div>%{{ rate }}</div>
    </div>
    <div
      class="crs-bar-container flex items-center w-full h-auto mt-3 border border-[#A5B2EC] rounded-full bg-[#080C25] overflow-hidden p-2"
    >
      <div class="crs-bar relative h-4 w-96" :style="{ width: `${rateWidth}px`, transition: 'width 0.8s ease-in-out' }">
        <OIcon icon="heart-red" class="w-6 h-6 absolute -right-3 top-1/2 -translate-y-1/2" />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api';
import { OIcon } from '@/modules/common/components/ui';

export default defineComponent({
  components: {
    OIcon,
  },
  props: {
    rate: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default: 'Aşk',
    },
  },
  setup(props) {
    const barWidth = ref(0);
    const rateWidth = ref(0);
    onMounted(() => {
      barWidth.value = document.querySelector('.crs-bar-container').offsetWidth - 24;
      rateWidth.value = (barWidth.value * props.rate) / 100;
    });
    return {
      rateWidth,
    };
  },
});
</script>

<style lang="scss">
@import '~/assets/css/custom-article.scss';
.crs-bar {
  border-top-left-radius: 19px;
  border-bottom-left-radius: 19px;
  background: linear-gradient(90deg, #991b22 0%, #ff2d39 100%);
}
</style>
